import Vue from 'vue'
import VeeValidate from "vee-validate"
import axios from 'axios';
import { GridInstaller } from '@progress/kendo-grid-vue-wrapper'
import {  encodeAndCompressToHash, decodeAndDecompressFromHash } from '../Shared/grid-utils'

if (document.getElementById('vue-portfolios-overview')) {
    const actionbar = require("../Actionbar/Actionbar.js");
    const alerts = require("../Alerts/Alerts.js");
    require("./Add.js");
    require("./Edit.js");

    Vue.use(GridInstaller);
    Vue.use(VeeValidate);

    new Vue({
        el: '#vue-portfolios-overview',
        components: {},
        data: function () {
            return {
                GridConfiguration: window.preLoadedData.GridConfiguration,
                AddModel: {
                    PortfolioName: ''
                },
                dataSource: {
                    data: [],
                    transport: {
                        saveToHash: undefined,
                        pageRefresh: true,
                        read: async function (options) {
                            const _this = this;
                            axios.post("/Portfolios/List", options.data)
                                .then(result => {
                                    _this.saveToHash();
                                    options.success(result.data);
                                }).catch(error => {
                                    options.error(error);
                                });                
                        },
                        parameterMap: function (options) {
                            return kendo.stringify(options);
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    pageSize: 20,
                    schema: {
                        data: "data",
                        total: "total"
                    }
                },
                pageable: {
                    buttonCount: 3,
                    info: true,
                    type: 'numeric',
                    pageSizes: [10, 20, 30, 50],
                    previousNext: true
                },
                columns: [
                    {
                        'field': 'selected',
                        'title': ' ',
                        'filterable': false,
                        'sortable': false,
                        'headerTemplate':
                            `<div>
                                <a class="visual-checkbox" href="\\#">
                                    <input type="checkbox" />
                                    <span class="checkmark"></span>
                                </a>
                            </div>`,
                        'template':
                            `<div #= selected ? \'class="state-selected"\' : "" #>
                                <a class="visual-checkbox" href="\\#">
                                    <input type="checkbox" #= selected ? \'checked="checked"\' : "" # />
                                    <span class="checkmark"></span>
                                </a>
                            </div>`,
                        'width': '40px'
                    },
                    { 'field': 'portFolioDisplayName', 'title': 'Portfolio', 'filterable': false },
                    { 'field': 'connectionType', 'title': 'Connect to', 'filterable': false },
                    { 'field': 'connections', 'title': 'Connections', 'filterable': false, 'template': '<span class="single-line">#: connections #</span>' },
                    { 'field': 'assetType', 'title': 'For assets of type', 'filterable': false },
                    { 'field': 'portfolioUsers', 'title': 'Users', 'filterable': false, 'template': '<span class="single-line">#: portfolioUsers #</span>' },
                    { 'title': ' ', 'filterable': false, 'template': '<a class="anchor-view" href="\\#"><span class="icon-rowaction icon-rowaction--dark icon-rowaction--view" title="View"></span></a><a class="anchor-edit" href="\\#""><span class="icon-rowaction icon-rowaction--dark icon-rowaction--edit" title="Edit"></span></a>', 'width': '90px' }
                ],
                actionbar: window.preLoadedData.Actionbar,
                currentHash: undefined,
                searchValue: undefined,
                popState: false,
                search: {
                    visible: true
                },
                alerts: []
            };
        },
        created: function () {
            this.actionbar.searchVisible = true;
            this.dataSource.transport.saveToHash = this.saveToHash;
        },
        mounted: async function () {
            const grid = this.$refs.grid.kendoWidget();
            const _this = this;
            grid.element.on('click', '.visual-checkbox',
                function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    const cb = this.querySelector("input[type='checkbox']");
                    cb.checked = !cb.checked;
                    if (cb.checked) {
                        $(this.parentElement).addClass("state-selected");
                    } else {
                        $(this.parentElement).removeClass("state-selected");
                    }
                    const dataItem = grid.dataItem($(this).closest("tr[data-uid"));
                    if (dataItem) {
                        dataItem.selected = cb.checked;
                    } else {
                        grid.dataSource.data().forEach(item => item.selected = cb.checked );
                    }

                    _this.selectOnChange();
                    grid.refresh();
                });
            
            //Get Delete portfolios button and set visibility to false on page load. Should only be visible when an item is selected.
            const deletePortfolioButton = this.actionbar.ItemsRight.find(f => f.event === "ab-delete-portfolios") ? this.actionbar.ItemsRight.find(f => f.event === "ab-delete-portfolios") : this.actionbar.ItemsLeft.find(f => f.event === "ab-delete-portfolios");
            if (deletePortfolioButton != null) {
                deletePortfolioButton.visible = false;
            }
   
            await this.restoreFromHash();

            window.onpopstate = function (event) {
                if (window.location.hash !== _this.currentHash) {
                    _this.popState = true;
                    _this.restoreFromHash();
                }
            };
        },
        methods: {
            /**
             * Save current state to URL hash
             */
            saveToHash: async function () {
                if (this.popState) {
                    this.currentHash = window.location.hash;
                    this.popState = false;
                    return;
                }
                const grid = this.$refs.grid.kendoWidget();
                const gridOptions = grid.getOptions();
                const objectToHash = {
                    searchValue: this.searchValue,
                    options: gridOptions
                };
                const encodedHash = await encodeAndCompressToHash(objectToHash);
                this.currentHash = `#${encodedHash}`;
                
                if (!window.location.hash) {
                    history.replaceState(null, "", window.location.href + this.currentHash);
                }
                window.location.hash = encodedHash;
            },

            /**
             * Restore grid state from URL hash
             * @param {*} fetch fetch data if true, false if not
             */
            restoreFromHash: async function () {
                const grid = this.$refs.grid.kendoWidget();
                let objectFromHash = null;
                const encodedHash = window.location.hash.replace('#', '');
                if (encodedHash) {
                    objectFromHash = await decodeAndDecompressFromHash(encodedHash);
                    if (objectFromHash.options) {
                        grid.setOptions(objectFromHash.options);    
                    }
                    this.searchValue = objectFromHash.searchValue;
                    if (this.searchValue) {
                        this.$refs.actionbar.updateSearchText(this.searchValue);
                    }
                }
            },            
            refreshGrid: function () {
                const grid = this.$refs.grid.kendoWidget();
                grid.dataSource.read();
            },
            addAlert: function (event) {
                this.alerts = [];
                this.alerts.push(event);
            },
            clearAlert: function (index) {
                this.alerts.splice(index, 1);
            },
            addTooltip: function addTooltipToTableHeaders(grid) {
                grid.element[0].querySelectorAll(".k-header").forEach(element => {
                    const title = $(element).data("title");

                    if (!/<[a-z\][\s\S]*>/i.test(title)) {

                        $(element).attr('title', title);
                    }
                });
            },
            actionbarSelectAll: function (checked) {
                const grid = this.$refs.grid.kendoWidget();
                if (checked) {
                    grid.dataSource.data().forEach(i => i.selected = true);
                } else {
                    grid.dataSource.data().forEach(i => i.selected = false);
                }
                this.setHeaderSelectAll(grid, checked);
                this.selectOnChange();
                grid.refresh();
            },
            setHeaderSelectAll: function (grid, checked)
            {
                const cb = grid.element[0].querySelector(".k-grid-header .visual-checkbox input[type='checkbox']");
                cb.checked = checked;
                if (cb.checked) {
                    $(cb.parentElement.parentElement).addClass("state-selected");

                } else {
                    $(cb.parentElement.parentElement).removeClass("state-selected");
                }
            },
            actionbarAddPortfolio: function () {
                $('#add-portfolio--enter-name').modal('show');
            },
            actionbarDeletePortfolios: function () {
                const grid = this.$refs.grid.kendoWidget();
                const selectedItems = grid.dataSource.data().filter(i => i.selected);
                if (selectedItems.length >= 1) {
                    $('#delete-portfolio--confirm').modal('show');
                } else {
                    alert('Please select one or more portfolio\'s to delete');
                }
            },
            confirmedDeletePortfolio: function () {
                const grid = this.$refs.grid.kendoWidget();
                const selectedItems = grid.dataSource.data().filter(i => i.selected).map(i => i.id);
                const _this = this;
                $.ajax({
                    type: "POST",
                    url: "/Portfolios/Delete",
                    data: JSON.stringify({
                        portfolioIds: selectedItems
                    }),
                    success: function (data) {
                        $("#delete-portfolio--confirm").modal('hide');

                        if (!data.success) {
                            _this.addAlert({
                                "message": data.message,
                                "isSuccess": false
                            });
                        } else {
                            _this.refreshGrid();
                        }
                    },
                    error: function (data) {
                        _this.addAlert({
                            "message": "Could not delete portfolio(\'s)!",
                            "isSuccess": false
                        });
                    },
                    contentType: "application/json",
                    dataType: 'json'
                });
            },
            actionbarSearch: function (e) {
                const grid = this.$refs.grid.kendoWidget();
                let filter = {};
                if (e !== null && e !== '') {
                    this.searchValue = e.trim();
                    filter = { logic: 'or', filters: [] };
                    grid.columns.forEach(function (x) {
                        if (x.field) {
                            filter.filters.push({
                                field: x.field,
                                operator: 'contains',
                                value: e.trim()
                            });
                        }
                    });
                } else {
                    this.searchValue = undefined;
                }
                grid.dataSource.filter(filter);
            },
            gridOnDatabound: function (e) {
                const grid = this.$refs.grid.kendoWidget();
                grid.element.unbind('dblclick');

                grid.element.on('dblclick', 'tbody tr[data-uid]',
                    function (e) {
                        const selectedItems = grid.select().toArray().map(function (s) { return grid.dataItem(s).id; });
                        if (selectedItems.length === 1) {
                            window.location.href = "./Portfolios/Details?id=" + selectedItems[0] + "&overviewUrl=" + encodeURIComponent(window.location.pathname + window.location.hash);
                        }
                    });

                grid.element.on('click', '.anchor-view',
                    function (e) {
                        e.preventDefault();
                        const selectedItems = grid.select().toArray().map(function (s) { return grid.dataItem(s).id; });
                        if (selectedItems.length === 1) {
                            window.location.href = "./Portfolios/Details?id=" + selectedItems[0] + "&overviewUrl=" + encodeURIComponent(window.location.pathname + window.location.hash);
                        }
                    });

                grid.element.on('click', '.anchor-edit',
                    function (e) {
                        e.preventDefault();
                        const selectedItems = grid.select().toArray().map(function (s) { return grid.dataItem(s).id; });
                        if (selectedItems.length === 1) {
                            window.location.href = "./Portfolios/Details?id=" + selectedItems[0] + "&action=edit&overviewUrl=" + encodeURIComponent(window.location.pathname + window.location.hash);
                        }
                    });

                this.addTooltip(grid);
            },
            selectOnChange: function () {
                const grid = this.$refs.grid.kendoWidget();
                const selected = grid.dataSource.data().filter(i => i.selected);

                const selectAll = document.getElementById('actionbarSelectAll');
                if (selectAll.checked && selected.length < grid.tbody[0].rows.length) {
                    selectAll.checked = false;
                }

                //Delete button Should only be visible when an item is selected.
                const deletePortfolioButton = this.actionbar.ItemsRight.find(f => f.event === "ab-delete-portfolios") ? this.actionbar.ItemsRight.find(f => f.event === "ab-delete-portfolios") : this.actionbar.ItemsLeft.find(f => f.event === "ab-delete-portfolios");
                if (deletePortfolioButton != null) {
                    deletePortfolioButton.visible = selected.length > 0;
                }   
            }
        }
    });
    $('.k-header').dblclick(function (e) {
        if (e.offsetY > $(this).outerHeight() - 2) {
            this.width = getTextWidth(this.textContent, this.font);
            //get column number
            const colNr = this.getAttribute("data-index");
            //select column
            //add search in class k-grid-content
            const gridCols = document.getElementById("portfolios-overview-grid").getElementsByClassName("k-grid-content")[0].querySelector("colgroup").childNodes;
            gridCols[colNr].width = $(this).outerWidth();
        }
    })
}
